var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIconaddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_10419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2854 31.0003H31.714C30.8461 31.0003 30.1426 30.2967 30.1426 29.4289V14.4289C30.1426 13.561 30.8461 12.8574 31.714 12.8574H40.2854C41.1533 12.8574 41.8569 13.561 41.8569 14.4289V29.4289C41.8569 30.2967 41.1533 31.0003 40.2854 31.0003ZM33.2854 27.8574H38.714V16.0003H33.2854V27.8574Z",
    fill: "#F24444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2854 46.0004H31.714C30.8461 46.0004 30.1426 45.2968 30.1426 44.429V35.8576C30.1426 34.9897 30.8461 34.2861 31.714 34.2861H40.2854C41.1533 34.2861 41.8569 34.9897 41.8569 35.8576V44.429C41.8569 45.2968 41.1533 46.0004 40.2854 46.0004ZM33.2854 42.8576H38.714V37.429H33.2854V42.8576Z",
    fill: "#F24444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7094 24.4197C52.9043 19.4643 49.413 13.2973 44.845 5.17629C43.0491 1.98343 39.6598 0 35.9997 0C32.3396 0 28.9503 1.98343 27.1541 5.17629C22.5477 13.3654 19.0395 19.5616 16.2207 24.5401C6.55169 41.6173 6.55169 41.6173 6.56983 44.1619C6.57041 44.2469 6.57112 44.3353 6.57112 44.4286C6.57112 50.0213 11.1213 54.5714 16.714 54.5714H30.1426V70.4286C30.1426 71.2964 30.8461 72 31.714 72H40.2854C41.1533 72 41.8568 71.2964 41.8568 70.4286V54.5714H55.2854C60.8781 54.5714 65.4283 50.0213 65.4283 44.4286C65.4283 44.3344 65.429 44.2451 65.4296 44.1596C65.4483 41.6231 65.4483 41.6231 55.7094 24.4197ZM38.714 68.8571H33.2854V54.5714H38.714V68.8571ZM62.2867 44.1364C62.286 44.2294 62.2853 44.3263 62.2853 44.4286C62.2853 48.2884 59.1451 51.4286 55.2853 51.4286H16.714C12.8541 51.4286 9.71398 48.2884 9.71398 44.4286C9.71398 44.3276 9.71326 44.2317 9.71269 44.1397C9.70098 42.499 9.70055 42.435 18.9557 26.0887C21.7755 21.1084 25.285 14.9101 29.8934 6.71714C31.1336 4.51271 33.4734 3.14286 35.9997 3.14286C38.5261 3.14286 40.8657 4.51243 42.1058 6.71714C46.676 14.8419 50.1684 21.011 52.9746 25.968C62.2993 42.4401 62.2988 42.5039 62.2867 44.1364Z",
    fill: "#030304"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_10419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconaddress);
export default __webpack_public_path__ + "static/media/Warning-icon(address).5aa308c71c2799ba59613e55afd5b701.svg";
export { ForwardRef as ReactComponent };